import { useQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import {
  IonButton,
  IonCol,
  IonLabel,
  IonRow,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";

//
import { Breadcrumbs } from "../../../components";

//
import { GET_MY_AGENCY } from "../../../graphql/queries/common.query";
import { GET_PACKAGE_PRICE_BY_SERVICE_TYPE } from "../../../graphql/queries/price.query";
import { isAuthenticated } from "../../../lib/utils/auth.utils";

//

//
const breadcrumbEntries = [{ title: "Rinnovo patenti - Pratiche auto" }];

//
export default function LincenseRenewalSpecialPricing() {
  const [price, setPrice] = useState<number>(0);
  const [isCalculated, setIsCalculated] = useState<boolean>(false);

  //
  const [agencyDetails, setAgencyDetails] = useState<any>();

  //
  const [licensePrice, setLicensePrice] = useState<any>(null);
  const [nauticaLicensePrice, setNauticaLicensePrice] = useState<any>(null);

  //
  const [siteValue, setSiteValue] = useState<Sites | null>(null);
  const [typeValue, setTypeValue] = useState<LicenseType | null>(null);

  if (isAuthenticated()) {
    useQuery(GET_MY_AGENCY, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setAgencyDetails(data.getMyAgency);
      },
    });
  }

  //
  useQuery(GET_PACKAGE_PRICE_BY_SERVICE_TYPE, {
    onCompleted(data) {
      const actualData = data.getPackagePriceBasedOnType?.data;
      if (!actualData) return;

      //
      setLicensePrice(actualData);
    },
    variables: { type: "licenseRenewal" },
  });

  //
  useQuery(GET_PACKAGE_PRICE_BY_SERVICE_TYPE, {
    onCompleted(data) {
      const actualData = data.getPackagePriceBasedOnType?.data;
      if (!actualData) return;

      //
      setNauticaLicensePrice(actualData);
    },
    variables: { type: "nauticalLicenseRenewal" },
  });

  //
  const priceDescription = useMemo(() => {
    if (licensePrice?.serviceItem?.description) {
      return licensePrice.serviceItem.description;
    }

    if (nauticaLicensePrice?.serviceItem?.description) {
      return nauticaLicensePrice.serviceItem.description;
    }

    return "";
  }, [licensePrice, nauticaLicensePrice]);

  //
  const typePrice = useMemo(() => {
    if (typeValue === "auto") return licensePrice;
    else return nauticaLicensePrice;
  }, [typeValue]);

  //
  const calculatePrice = () => {
    if (!typeValue || !siteValue) return;

    //
    const priceValues = typePrice?.packagePrice ?? [];

    const sitePrice = priceValues.find(
      (price: any) => price.location === siteValue
    );

    if (!sitePrice) return;

    //
    const discountType = agencyDetails?.client?.discount;

    //
    if (discountType === "premium") {
      setPrice(sitePrice.premiumPrice);
    } else if (discountType === "gold") {
      setPrice(sitePrice.goldPrice);
    } else {
      setPrice(sitePrice.basicPrice);
    }

    //
    setIsCalculated(true);
  };

  //
  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} backButton />

      <div className="order-page-wrapper order-page-wrapper-details">
        <IonRow className="height-full">
          <IonCol
            sizeSm="12"
            sizeMd="12"
            sizeLg="5"
            sizeXs="12"
            className="order-input-section"
          >
            <h1 className="details-title">Rinnovo patenti</h1>

            <hr />

            <div>
              <div className="details-option">
                <IonLabel>Tipo Patente</IonLabel>
                <IonSelect
                  value={typeValue}
                  onIonChange={(e) => {
                    setTypeValue(e.detail.value);
                  }}
                  interface="alert"
                  className="detail-selector"
                >
                  <IonSelectOption value="auto" key="auto">
                    Auto
                  </IonSelectOption>
                  <IonSelectOption value="nautica" key="nautica">
                    Nautica
                  </IonSelectOption>
                </IonSelect>
              </div>

              <div className="details-option">
                <IonLabel>Sede in cui effettuare il servizio</IonLabel>
                <IonSelect
                  value={siteValue}
                  onIonChange={(e) => {
                    setSiteValue(e.detail.value);
                  }}
                  interface="alert"
                  className="detail-selector"
                >
                  <IonSelectOption value="milano" defaultChecked>
                    Milano, Via Rembrandt 22
                  </IonSelectOption>
                  <IonSelectOption value="monza">
                    Monza, Viale Vittorio Veneto 5, 20090 Monza
                  </IonSelectOption>
                </IonSelect>
              </div>

              <div className="details-option">
                <IonButton
                  disabled={!(typeValue && siteValue)}
                  expand="full"
                  shape="round"
                  className="details-button"
                  onClick={calculatePrice}
                >
                  Calcola
                </IonButton>
              </div>

              {isCalculated && (
                <div className="price-group">
                  <span className="price-group-label">da</span>
                  <div className="price-item">
                    <strong>€ {price}</strong>
                  </div>
                </div>
              )}
            </div>
          </IonCol>
          <IonCol
            sizeSm="12"
            offset-lg="1"
            sizeMd="12"
            sizeLg="6"
            sizeXs="12"
            className="order-extra-details"
          >
            <div className="order-extra-container">
              {priceDescription && <p>{priceDescription}</p>}

              <div>
                <h4>
                  <strong>
                    Per fare questa pratica devi venirci a trovare
                  </strong>
                </h4>
              </div>
              <div className="order-extra-details-item">
                <IonButton
                  expand="full"
                  shape="round"
                  className="details-button"
                  href="https://www.cosmilano.it/prenota-visita-patente/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Prenota appuntamento
                </IonButton>
              </div>
            </div>
          </IonCol>
        </IonRow>
      </div>
    </div>
  );
}

//
type Sites = "milano" | "monza";
type LicenseType = "auto" | "nautica";
